enum MapKeyExpressionType {
    MatchedRuleResult = '00000000-0000-0000-0000-000000000001',
    RuleResult = '00000000-0000-0000-0000-000000000002'
}

export { MapKeyExpressionType };
